import { Controller } from "@hotwired/stimulus";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

export default class extends Controller {
  connect() {
    const options = JSON.parse(
      this.element.dataset.intlTelInputOptions || "{}"
    );

    // Add the utils.js path to the options
    options.utilsScript = "/node_modules/intl-tel-input/build/js/utils.js";

    this.iti = intlTelInput(this.element, options);
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy();
    }
  }
}
